export const locale = {
  sunday: 'Dom',
  monday: 'Seg',
  tuesday: 'Ter',
  wednesday: 'Qua',
  thursday: 'Qui',
  friday: 'Sex',
  saturday: 'Sab',
  ok: 'Ok',
  today: 'Hoje',
  yesterday: 'Ontem',
  hours: 'Horas',
  minutes: 'Minutos',
  seconds: 'Segundos',
};

export const periodoDataGraficos = [
  {
    label: '1 Semana',
    value: '1semana',
  },
  {
    label: '1 Mês',
    value: '1mes',
  },
  {
    label: '6 Meses',
    value: '6meses',
  },
  {
    label: '1 Ano',
    value: '1ano',
  },
  {
    label: '2 Anos',
    value: '2anos',
  },
  {
    label: 'Todo Período',
    value: 'all',
  },
];

export const anosGraficos = Array.from({ length: 2500 - 1900 + 1 }, (_, i) => {
  const year = (1900 + i).toString();
  return { label: year, value: year };
});
